import {AppThunkAction} from '../../../types/redux'
import {
  aFetchLegalRepresentatives,
  selectLegalRepresentativesWhereLoaded,
} from '../../../data/legal-representatives'

export const selectLegalRepresentativeItemsArePending = (state: Record<string, any>): boolean =>
  !selectLegalRepresentativesWhereLoaded(state)

export const aInitializeLegalRepresentativeItems =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchLegalRepresentatives())
  }
